"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _mapKeys2 = _interopRequireDefault(require("lodash/mapKeys"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _pull2 = _interopRequireDefault(require("lodash/pull"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _sortBy2 = _interopRequireDefault(require("lodash/sortBy"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _checkmark = _interopRequireDefault(require("cccisd-icons/checkmark4"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle"));
var _undo = _interopRequireDefault(require("cccisd-icons/undo"));
var _cancelSquare = _interopRequireDefault(require("cccisd-icons/cancel-square"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdValidator = _interopRequireDefault(require("cccisd-validator"));
var _admin = require("../../selectors/admin.js");
var _LanguageToggle = _interopRequireDefault(require("./LanguageToggle"));
var _MessageViewer = _interopRequireDefault(require("./MessageViewer"));
var _Scheduler = _interopRequireDefault(require("./Scheduler.js"));
var _modalstyle_saveMessageScheduleMessage = _interopRequireDefault(require("./modalstyle_saveMessageScheduleMessage.css"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NOTE = 'NOTIFICATION';
var initialMessageInfo = {
  en: {
    subject: '',
    body: 'Hello %firstName%,',
    outroLines: '',
    actionText: 'Take survey',
    actionUrl: '%URL%'
  },
  es: {
    subject: '',
    body: 'Hola %firstName%,',
    outroLines: '',
    actionText: 'Tomar encuesta',
    actionUrl: '%URL%'
  }
};
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var moduleCompleteConditions = ['on_respondent_complete_module', 'on_respondent_complete_module_notify'];
var surveyCompleteConditions = ['on_respondent_complete_survey', 'on_respondent_complete_survey_notify'];
var SaveMessageModalContents = /*#__PURE__*/function (_React$Component) {
  function SaveMessageModalContents() {
    var _this;
    _classCallCheck(this, SaveMessageModalContents);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SaveMessageModalContents, [].concat(args));
    _defineProperty(_this, "state", {
      hasInitialized: false,
      hasSubmitted: false,
      hasScheduleError: false,
      isRecipientListCollapsed: true,
      isAddingRecipient: false,
      isSubmitting: false,
      emailRecipients: [],
      smsRecipients: [],
      currentlyEditingRecList: [],
      recEdits: {},
      children: [],
      label: '',
      // new message values
      condition: '',
      method: 'email',
      scheduleOffset: '',
      scheduleOffsetNumber: '',
      scheduleOffsetUnits: 'day',
      recipientsType: '',
      moduleId: '',
      surveyHandle: '',
      duplicateLabel: false
    });
    _defineProperty(_this, "initializeState", function () {
      var messageObj = _this.props.messageObj;
      var buildLanguages = _this.getLanguages(true);
      var currLang = Array.isArray(buildLanguages) && buildLanguages.length > 0 ? buildLanguages[0] : 'en';
      var initialMessageinfo = buildLanguages.reduce(function (allInitial, lang) {
        if (lang === 'en') {
          return _objectSpread(_objectSpread({}, allInitial), _this.getInitialMessageInfoPerLanguage(lang));
        }
        return _objectSpread(_objectSpread({}, allInitial), {}, _defineProperty({}, lang, _objectSpread({}, _this.getInitialMessageInfoPerLanguage(lang))));
      }, {});
      if (messageObj === null) {
        _this.setState(_objectSpread({
          hasInitialized: true,
          currLang: currLang
        }, initialMessageinfo));
        return;
      }
      var children = [];
      if (messageObj.children.length) {
        var _iterator = _createForOfIteratorHelper(messageObj.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;
            if (!child.condition.startsWith('scheduled_')) {
              children.push({
                id: child.messageId,
                scheduleTime: child.scheduleTime
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var scheduleOffset = messageObj.scheduleOffset || '';
      var scheduleOffsetParts = scheduleOffset.split(' ').filter(function (item) {
        return item;
      });
      var scheduleOffsetNumber = scheduleOffsetParts.length >= 2 ? scheduleOffsetParts[0] : '';
      var scheduleOffsetUnits = scheduleOffsetParts.length >= 2 ? scheduleOffsetParts[1] : 'day';
      _this.setState(_objectSpread(_objectSpread({
        hasInitialized: true,
        label: messageObj.settings.label,
        children: children,
        // new message values
        condition: messageObj.condition,
        currLang: currLang,
        method: messageObj.messageMethod,
        scheduleOffset: scheduleOffset,
        scheduleOffsetNumber: scheduleOffsetNumber,
        scheduleOffsetUnits: scheduleOffsetUnits,
        recipientsType: messageObj.settings.recipientsType,
        moduleId: messageObj.settings.moduleId || '',
        surveyHandle: messageObj.settings.surveyHandle || ''
      }, initialMessageinfo), {}, _defineProperty({}, messageObj.messageMethod === 'email' ? 'emailRecipients' : 'smsRecipients', messageObj.recipients !== null ? _toConsumableArray(messageObj.recipients) : [])));
    });
    _defineProperty(_this, "getErrors", function () {
      var errors = {};
      var _this$state = _this.state,
        children = _this$state.children,
        condition = _this$state.condition,
        duplicateLabel = _this$state.duplicateLabel,
        emailRecipients = _this$state.emailRecipients,
        hasScheduleError = _this$state.hasScheduleError,
        label = _this$state.label,
        method = _this$state.method,
        moduleId = _this$state.moduleId,
        smsRecipients = _this$state.smsRecipients,
        surveyHandle = _this$state.surveyHandle;
      if (hasScheduleError) {
        errors.scheduleError = 'You must resolve the noted schedule errors';
      }
      if (duplicateLabel) {
        errors.label = 'Please use a different label';
      }
      if (!label) {
        errors.label = 'You must provide a Label';
      }
      if (!condition) {
        errors.condition = 'You must select a Condition';
      } else if (['target_met', 'on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify'].includes(condition) || ['target_not_met'].includes(condition) && children.length) {
        if (method === 'email' && !emailRecipients.length) {
          errors.recipients = 'You must specify recipients';
        }
        if (method === 'sms' && !smsRecipients.length) {
          errors.recipients = 'You must specify recipients';
        }
      }
      if (moduleCompleteConditions.includes(condition) && !moduleId) {
        errors.moduleId = 'You must select a Module';
      }
      if (surveyCompleteConditions.includes(condition) && !surveyHandle) {
        errors.surveyHandle = 'You must select a Survey';
      }
      var deployedLanguages = _this.getLanguages(false);
      deployedLanguages.forEach(function (lang) {
        var prefix = lang === 'en' ? '' : "".concat(lang, ".");
        var subject = (0, _get2["default"])(_this.state, "".concat(prefix, "subject"));
        var body = (0, _get2["default"])(_this.state, "".concat(prefix, "body"));
        var outroLines = (0, _get2["default"])(_this.state, "".concat(prefix, "outroLines"));
        var actionText = (0, _get2["default"])(_this.state, "".concat(prefix, "actionText"));
        var actionUrl = (0, _get2["default"])(_this.state, "".concat(prefix, "actionUrl"));
        if (method === 'email') {
          if (actionText && !actionUrl) {
            (0, _set2["default"])(errors, "".concat(prefix, "actionUrl"), 'You must supply a Button URL if Button Text is provided');
          }
          if (!actionText && actionUrl) {
            (0, _set2["default"])(errors, "".concat(prefix, "actionText"), 'You must supply Button Text if a Button URL is provided');
          }
          if (!subject) {
            (0, _set2["default"])(errors, "".concat(prefix, "subject"), 'You must supply a Subject');
          }
          if ((!body || body === initialMessageInfo[lang].body) && !outroLines) {
            (0, _set2["default"])(errors, "".concat(prefix, "body"), 'You must supply either Body (upper) or Body (lower)');
            (0, _set2["default"])(errors, "".concat(prefix, "outroLines"), 'You must supply either Body (upper) or Body (lower)');
          }
        } else if (!body || body === initialMessageInfo[lang].body) {
          (0, _set2["default"])(errors, "".concat(prefix, "body"), 'You must supply a Body');
        }
      });
      return errors;
    });
    _defineProperty(_this, "getLanguages", function (isBuildOnly) {
      var _currentAssignment$se, _currentAssignment$se2;
      // Multi-lingual capabilities is only for Respondents
      var recipientsType = _this.state.recipientsType;
      if (recipientsType.toUpperCase() === NOTE) {
        return ['en'];
      }
      var currentAssignment = _this.props.currentAssignment;
      var buildLanguages = ['en'];

      // we changed this JSON structure, so older Quests might not have buildLanguages
      if (isBuildOnly && Array.isArray(currentAssignment === null || currentAssignment === void 0 ? void 0 : (_currentAssignment$se = currentAssignment.settings) === null || _currentAssignment$se === void 0 ? void 0 : _currentAssignment$se.buildLanguages)) {
        buildLanguages = currentAssignment.settings.buildLanguages;
      } else if (Array.isArray(currentAssignment === null || currentAssignment === void 0 ? void 0 : (_currentAssignment$se2 = currentAssignment.settings) === null || _currentAssignment$se2 === void 0 ? void 0 : _currentAssignment$se2.languages)) {
        buildLanguages = currentAssignment.settings.languages;
      }
      if (buildLanguages.length === 0) {
        buildLanguages = ['en'];
      }
      return buildLanguages;
    });
    _defineProperty(_this, "getInitialMessageInfoPerLanguage", function (lang) {
      var _this$props, _this$props$messageOb;
      var initialInfo = (_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$messageOb = _this$props.messageObj) === null || _this$props$messageOb === void 0 ? void 0 : _this$props$messageOb.messageInfo;
      if (initialInfo) {
        var _initialInfo$lang, _initialInfo$lang2, _initialInfo$lang3, _initialInfo$lang4, _initialInfo$lang5;
        return {
          subject: (lang === 'en' ? initialInfo.subject : (_initialInfo$lang = initialInfo[lang]) === null || _initialInfo$lang === void 0 ? void 0 : _initialInfo$lang.subject) || '',
          body: (lang === 'en' ? initialInfo.body : (_initialInfo$lang2 = initialInfo[lang]) === null || _initialInfo$lang2 === void 0 ? void 0 : _initialInfo$lang2.body) || '',
          // body-top
          actionText: (lang === 'en' ? initialInfo.actionText : (_initialInfo$lang3 = initialInfo[lang]) === null || _initialInfo$lang3 === void 0 ? void 0 : _initialInfo$lang3.actionText) || '',
          actionUrl: (lang === 'en' ? initialInfo.actionUrl : (_initialInfo$lang4 = initialInfo[lang]) === null || _initialInfo$lang4 === void 0 ? void 0 : _initialInfo$lang4.actionUrl) || '',
          outroLines: (lang === 'en' ? initialInfo.outroLines : (_initialInfo$lang5 = initialInfo[lang]) === null || _initialInfo$lang5 === void 0 ? void 0 : _initialInfo$lang5.outroLines) || '' // body-bottom
        };
      }
      if (lang in initialMessageInfo) {
        return initialMessageInfo[lang];
      }
      return {
        subject: '',
        body: '',
        outroLines: '',
        actionText: '',
        actionUrl: ''
      };
    });
    _defineProperty(_this, "setMessageInfoPerLanguage", function (key, value) {
      var currLang = _this.state.currLang;
      if (!currLang || !key || !['body', 'subject', 'outroLines', 'actionText', 'actionUrl'].includes(key)) {
        console.error('Missing param in `setMessageInfoPerLanguage`');
        return;
      }
      _this.setState(function (prevState) {
        if (currLang === 'en') {
          return _defineProperty({}, key, value);
        }
        return _defineProperty({}, currLang, _objectSpread(_objectSpread({}, prevState[currLang]), {}, _defineProperty({}, key, value)));
      });
    });
    // toggle if card is collapsed or expanded
    _defineProperty(_this, "toggleCollapse", function () {
      _this.setState(function (prevState) {
        return {
          isRecipientListCollapsed: !prevState.isRecipientListCollapsed,
          isAddingRecipient: false
        };
      });
    });
    // return the full message info object based on message type (email or sms)
    _defineProperty(_this, "getMessageInfoObject", function () {
      var buildLanguages = _this.getLanguages(true);
      var isEmail = _this.state.method.toUpperCase() === 'EMAIL';
      return buildLanguages.reduce(function (messageInfo, lang) {
        var prefix = lang === 'en' ? '' : "".concat(lang, ".");
        (0, _set2["default"])(messageInfo, "".concat(prefix, "body"), (0, _get2["default"])(_this.state, "".concat(prefix, "body")));
        if (isEmail) {
          (0, _set2["default"])(messageInfo, "".concat(prefix, "subject"), (0, _get2["default"])(_this.state, "".concat(prefix, "subject")));
          (0, _set2["default"])(messageInfo, "".concat(prefix, "outroLines"), (0, _get2["default"])(_this.state, "".concat(prefix, "outroLines")));
          (0, _set2["default"])(messageInfo, "".concat(prefix, "actionText"), (0, _get2["default"])(_this.state, "".concat(prefix, "actionText")));
          (0, _set2["default"])(messageInfo, "".concat(prefix, "actionUrl"), (0, _get2["default"])(_this.state, "".concat(prefix, "actionUrl")));
        }
        return messageInfo;
      }, {});
    });
    _defineProperty(_this, "onChildrenChange", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(children) {
        var processedChildren, _iterator2, _step2, child, copyChild;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              processedChildren = [];
              _iterator2 = _createForOfIteratorHelper(children);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  child = _step2.value;
                  copyChild = Object.assign({}, child);
                  if (!copyChild.isNew) {
                    copyChild.id = copyChild.messageId;
                  }
                  delete copyChild.messageId;
                  processedChildren.push(copyChild);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context.n = 1;
              return _this.setState({
                children: processedChildren
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onSaveSubmit", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _this$props2, deploymentId, closeModal, _this$state2, children, condition, emailRecipients, label, method, moduleId, recipientsType, scheduleOffset, smsRecipients, surveyHandle, messageData, recipientConditions, response, errorData;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return _this.setState({
              hasSubmitted: true
            });
          case 1:
            if (!(Object.keys(_this.getErrors()).length > 0)) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return _this.setState({
              isSubmitting: false
            });
          case 2:
            return _context2.a(2);
          case 3:
            _this$props2 = _this.props, deploymentId = _this$props2.deploymentId, closeModal = _this$props2.closeModal;
            _this$state2 = _this.state, children = _this$state2.children, condition = _this$state2.condition, emailRecipients = _this$state2.emailRecipients, label = _this$state2.label, method = _this$state2.method, moduleId = _this$state2.moduleId, recipientsType = _this$state2.recipientsType, scheduleOffset = _this$state2.scheduleOffset, smsRecipients = _this$state2.smsRecipients, surveyHandle = _this$state2.surveyHandle;
            messageData = {
              condition: condition,
              messageMethod: method,
              messageInfo: _this.getMessageInfoObject(),
              scheduleOffset: scheduleOffset,
              settings: {
                label: label,
                recipientsType: recipientsType
              },
              children: children
            };
            if (moduleCompleteConditions.includes(condition)) {
              messageData.settings.moduleId = moduleId;
            }
            if (surveyCompleteConditions.includes(condition)) {
              messageData.settings.surveyHandle = surveyHandle;
            }
            recipientConditions = ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify', 'target_met', 'target_not_met'];
            if (recipientConditions.includes(condition)) {
              messageData.recipients = method === 'email' ? emailRecipients : smsRecipients;
            }
            _context2.n = 4;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeploymentMessage.store', {
              deploymentId: deploymentId
            }), messageData);
          case 4:
            response = _context2.v;
            if (!(response.data.status === 'success')) {
              _context2.n = 6;
              break;
            }
            _context2.n = 5;
            return _this.props.requeryCallback();
          case 5:
            closeModal();
            _this.setState({
              isSubmitting: false
            });
            return _context2.a(2, (0, _cccisdNotification["default"])({
              type: 'success',
              message: "Successfully saved ".concat(recipientsType, " message '").concat(label, "'")
            }));
          case 6:
            errorData = response.data && response.data.errors || {};
            if (Object.keys(errorData).length) {
              console.error(errorData);
            }
            _this.setState({
              isSubmitting: false
            });
            return _context2.a(2, (0, _cccisdNotification["default"])({
              type: 'danger',
              message: "Failed to save message ".concat(label)
            }));
        }
      }, _callee2);
    })));
    // actions when the submit button is clicked - UPDATE
    _defineProperty(_this, "onEditSubmit", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _this$props3, messageObj, deploymentId, closeModal, _this$state3, children, condition, emailRecipients, label, method, moduleId, recipientsType, scheduleOffset, smsRecipients, surveyHandle, updateParams, response, errorData;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return _this.setState({
              hasSubmitted: true
            });
          case 1:
            if (!(Object.keys(_this.getErrors()).length > 0)) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return _this.setState({
              isSubmitting: false
            });
          case 2:
            return _context3.a(2);
          case 3:
            _this$props3 = _this.props, messageObj = _this$props3.messageObj, deploymentId = _this$props3.deploymentId, closeModal = _this$props3.closeModal;
            _this$state3 = _this.state, children = _this$state3.children, condition = _this$state3.condition, emailRecipients = _this$state3.emailRecipients, label = _this$state3.label, method = _this$state3.method, moduleId = _this$state3.moduleId, recipientsType = _this$state3.recipientsType, scheduleOffset = _this$state3.scheduleOffset, smsRecipients = _this$state3.smsRecipients, surveyHandle = _this$state3.surveyHandle;
            updateParams = {
              condition: condition,
              messageMethod: method,
              recipients: method === 'email' ? emailRecipients : smsRecipients,
              messageInfo: _this.getMessageInfoObject(),
              scheduleOffset: scheduleOffset,
              settings: _objectSpread(_objectSpread({}, messageObj.settings), {}, {
                label: label,
                recipientsType: recipientsType
              }),
              children: children
            };
            if (moduleCompleteConditions.includes(condition)) {
              updateParams.settings.moduleId = moduleId;
            }
            if (surveyCompleteConditions.includes(condition)) {
              updateParams.settings.surveyHandle = surveyHandle;
            }
            _context3.n = 4;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeploymentMessage.update', {
              deploymentId: deploymentId,
              deploymentMessageId: messageObj.messageId
            }), updateParams);
          case 4:
            response = _context3.v;
            if (!(response.data.status === 'success')) {
              _context3.n = 6;
              break;
            }
            _context3.n = 5;
            return _this.props.requeryCallback();
          case 5:
            closeModal();
            _this.setState({
              isSubmitting: false
            });
            return _context3.a(2, (0, _cccisdNotification["default"])({
              type: 'success',
              message: "Successfully updated ".concat(recipientsType, " message '").concat(label, "'")
            }));
          case 6:
            errorData = response.data && response.data.errors || {};
            if (Object.keys(errorData).length) {
              console.error(errorData);
            }
            _this.setState({
              isSubmitting: false
            });
            return _context3.a(2, (0, _cccisdNotification["default"])({
              type: 'danger',
              message: "Failed to update message ".concat(label)
            }));
        }
      }, _callee3);
    })));
    _defineProperty(_this, "onScheduleError", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return _this.setState({
              hasScheduleError: true
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    })));
    _defineProperty(_this, "onScheduleErrorResolved", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return _this.setState({
              hasScheduleError: false
            });
          case 1:
            return _context5.a(2);
        }
      }, _callee5);
    })));
    /**
     * Transform the value to an integer; if result is not valid, set
     * scheduleOffset to be empty.
     */
    _defineProperty(_this, "onScheduleOffsetNumberChange", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(value) {
        var scheduleOffsetUnits, parsedValue, newScheduleOffsetNumber, newScheduleOffset;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              scheduleOffsetUnits = _this.state.scheduleOffsetUnits;
              parsedValue = Number.parseInt(value, 10);
              newScheduleOffsetNumber = parsedValue > 0 ? parsedValue : '';
              newScheduleOffset = newScheduleOffsetNumber ? "".concat(newScheduleOffsetNumber, " ").concat(scheduleOffsetUnits) : '';
              _context6.n = 1;
              return _this.setState({
                scheduleOffset: newScheduleOffset,
                scheduleOffsetNumber: newScheduleOffsetNumber
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onScheduleOffsetUnitsChange", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(value) {
        var scheduleOffsetNumber, newScheduleOffset;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              scheduleOffsetNumber = _this.state.scheduleOffsetNumber;
              newScheduleOffset = scheduleOffsetNumber ? "".concat(scheduleOffsetNumber, " ").concat(value) : '';
              _context7.n = 1;
              return _this.setState({
                scheduleOffset: newScheduleOffset,
                scheduleOffsetUnits: value
              });
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }));
      return function (_x3) {
        return _ref9.apply(this, arguments);
      };
    }());
    // recipients list and buttons
    _defineProperty(_this, "_renderRecipientsList", function () {
      var _this$state4 = _this.state,
        currentlyEditingRecList = _this$state4.currentlyEditingRecList,
        emailRecipients = _this$state4.emailRecipients,
        isAddingRecipient = _this$state4.isAddingRecipient,
        isRecipientListCollapsed = _this$state4.isRecipientListCollapsed,
        isSubmitting = _this$state4.isSubmitting,
        method = _this$state4.method,
        recEdits = _this$state4.recEdits,
        smsRecipients = _this$state4.smsRecipients;
      if (isRecipientListCollapsed) {
        return;
      }
      var isEmail = method === 'email';
      var currList = isEmail ? emailRecipients : smsRecipients;

      // EDITING BOX
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card-body', _modalstyle_saveMessageScheduleMessage["default"].panelList)
      }, (0, _map2["default"])(currList, function (rec) {
        // if editing receiver
        if ((0, _includes2["default"])(currentlyEditingRecList, rec)) {
          return /*#__PURE__*/_react["default"].createElement("label", {
            key: rec,
            className: "mb-3",
            htmlFor: "recipient_editing"
          }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
            title: rec
          }, /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames["default"])('btn btn-secondary', _modalstyle_saveMessageScheduleMessage["default"].cancel, isSubmitting && 'disabled'),
            onClick: function onClick() {
              if (!isSubmitting) {
                _this.undoEditingRecipient(rec);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null))), /*#__PURE__*/_react["default"].createElement("input", {
            className: "form-control",
            type: isEmail ? 'email' : 'tel',
            name: "recipient_editing",
            id: "recipient_editing",
            placeholder: isEmail ? 'Email address' : 'Phone number',
            defaultValue: recEdits[rec],
            onChange: function onChange(e) {
              _this.setState({
                recEdits: _objectSpread(_objectSpread({}, recEdits), {}, _defineProperty({}, rec, e.target.value))
              });
            }
          }), /*#__PURE__*/_react["default"].createElement("a", {
            className: (0, _classnames["default"])('btn btn-primary', _modalstyle_saveMessageScheduleMessage["default"].add, isSubmitting && 'disabled'),
            onClick: function onClick() {
              if (!isSubmitting) {
                _this.updateEditingRecipient(rec, recEdits[rec]);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_checkmark["default"], null)));
        }

        // if not editing receiver
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: rec
        }, /*#__PURE__*/_react["default"].createElement("p", {
          className: _modalstyle_saveMessageScheduleMessage["default"].editReceiver,
          onClick: function onClick() {
            if (!isSubmitting) {
              _this.editRecipient(rec);
            }
          }
        }, rec), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Delete",
          type: "error"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          className: (0, _classnames["default"])('btn btn-danger', _modalstyle_saveMessageScheduleMessage["default"]["delete"], isSubmitting && 'disabled'),
          onClick: function onClick() {
            if (!isSubmitting) {
              _this.removeRecipient(rec);
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))));
      }), isAddingRecipient ? /*#__PURE__*/_react["default"].createElement("label", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-secondary', _modalstyle_saveMessageScheduleMessage["default"].cancel, isSubmitting && 'disabled'),
        onClick: function onClick() {
          if (!isSubmitting) {
            _this.setState({
              isAddingRecipient: false
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_cancelSquare["default"], null)), /*#__PURE__*/_react["default"].createElement("input", {
        className: "form-control",
        type: isEmail ? 'email' : 'tel',
        placeholder: isEmail ? 'Email address' : 'Phone number',
        ref: function ref(input) {
          _this.recipientToBeAdded = input;
        }
      }), /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-primary', _modalstyle_saveMessageScheduleMessage["default"].add),
        onClick: _this.addRecipient
      }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null))) : /*#__PURE__*/_react["default"].createElement("label", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: (0, _classnames["default"])('btn btn-secondary', _modalstyle_saveMessageScheduleMessage["default"].addRecipientButton, isSubmitting && 'disabled'),
        onClick: function onClick() {
          if (!isSubmitting) {
            _this.setState({
              isAddingRecipient: true
            });
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add ", isEmail ? 'Email Address' : 'Phone Number')));
    });
    _defineProperty(_this, "addRecipient", function () {
      var isEmail = _this.state.method === 'email';
      var recipient = _this.recipientToBeAdded.value.trim();
      if (recipient === '') {
        _this.setState({
          isAddingRecipient: false
        });
        return;
      }
      var validationResult = (0, _cccisdValidator["default"])(recipient, {
        types: isEmail ? ['email'] : ['phoneNumber']
      });
      if (validationResult.status === 'fail') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: validationResult.errors[Object.keys(validationResult.errors)[0]]
        });
      }
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipientList = _this.state[key];
      if (recipientList.includes(recipient)) {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(recipient, " already exists")
        });
      }
      recipientList.push(recipient);
      _this.setState(_defineProperty(_defineProperty(_defineProperty({}, key, recipientList), "isAddingRecipient", false), "newRecipient", ''));
    });
    _defineProperty(_this, "removeRecipient", function (recipient) {
      var isEmail = _this.state.method === 'email';
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipientList = _this.state[key];
      (0, _pull2["default"])(recipientList, recipient);
      _this.setState(_defineProperty({}, key, recipientList));
    });
    // edit recipient area
    _defineProperty(_this, "editRecipient", function (recipient) {
      if (!(0, _includes2["default"])(_this.state.currentlyEditingRecList, recipient)) {
        var newList = _this.state.currentlyEditingRecList;
        newList.push(recipient);
        _this.setState({
          currentlyEditingRecList: newList,
          recEdits: _objectSpread(_objectSpread({}, _this.state.recEdits), {}, _defineProperty({}, recipient, recipient))
        });
      }
    });
    // update recipient
    _defineProperty(_this, "updateEditingRecipient", function (oldVal, newVal) {
      var isEmail = _this.state.method === 'email';
      if (newVal === '') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: 'Updated value was empty'
        });
      }
      var validationResult = (0, _cccisdValidator["default"])(newVal, {
        types: isEmail ? ['email'] : ['phoneNumber']
      });
      if (validationResult.status === 'fail') {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: validationResult.errors[Object.keys(validationResult.errors)[0]]
        });
      }
      var key = isEmail ? 'emailRecipients' : 'smsRecipients';
      var recipList = _this.state[key];
      if (recipList.includes(newVal)) {
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(newVal, " already exists")
        });
      }

      // replace value
      var recIndex = recipList.indexOf(oldVal);
      if (recIndex !== -1) {
        recipList[recIndex] = newVal;
      } else {
        // SHOULD NEVER HAPPEN
        return (0, _cccisdNotification["default"])({
          type: 'danger',
          message: "".concat(oldVal, " not found")
        });
      }
      _this.setState(_defineProperty({}, key, recipList));

      // remove from editing lists
      _this.undoEditingRecipient(oldVal);
    });
    // update all recipients being edited (on submit)
    _defineProperty(_this, "updateAllEditingRecipients", function () {
      (0, _mapKeys2["default"])(_this.state.recEdits, function (val, key) {
        _this.updateEditingRecipient(key, val);
      });
    });
    // remove recipient editing list
    _defineProperty(_this, "undoEditingRecipient", function (recipient) {
      var recList = (0, _omit2["default"])(_this.state.recEdits, [recipient]);
      var editList = _this.state.currentlyEditingRecList;
      (0, _pull2["default"])(editList, recipient);
      _this.setState({
        currentlyEditingRecList: editList,
        recEdits: recList
      });
    });
    // determine if the condition uses the scheduler
    _defineProperty(_this, "useScheduler", function (condition) {
      return !['target_met', 'on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered', ''].includes(condition.toLowerCase());
    });
    _defineProperty(_this, "_getConditions", function () {
      var _this$props4 = _this.props,
        deploymentId = _this$props4.deploymentId,
        deployments = _this$props4.deployments,
        isEditing = _this$props4.isEditing;
      var _this$state5 = _this.state,
        condition = _this$state5.condition,
        recipientsType = _this$state5.recipientsType;
      var conditions = [{
        value: '',
        label: '-- Choose condition --'
      }];
      var respondentTriggeredConditions = [{
        value: 'on_respondent_complete',
        label: 'Send on respondent complete'
      }, {
        value: 'on_respondent_complete_survey',
        label: 'Send on respondent completion of a survey'
      }];
      if (_this._hasModules()) {
        respondentTriggeredConditions.push({
          value: 'on_respondent_complete_module',
          label: 'Send on respondent completion of a module'
        });
      }
      var deployment = deployments.find(function (d) {
        return d.deploymentId === deploymentId;
      }) || {};
      if (deployment.type === 'known' || (0, _get2["default"])(deployment, 'settings.closedRoster')) {
        respondentTriggeredConditions.push({
          value: 'on_respondent_rostered',
          label: 'Send on respondent added to roster'
        });
      }
      var respondentScheduledConditions = [{
        value: 'all_respondents',
        label: 'All respondents'
      }, {
        value: 'not_started',
        label: 'All not started'
      },
      // TODO: only include if not anonymous
      {
        value: 'incomplete',
        label: 'All partially completed'
      }, {
        value: 'incomplete_or_not_started',
        label: 'All partially completed or not started'
      }, {
        value: 'complete',
        label: 'All completed'
      }];
      var receiverTriggeredConditions = [{
        value: 'on_respondent_complete_notify',
        label: 'Send on respondent complete'
      }, {
        value: 'on_respondent_complete_survey_notify',
        label: 'Send on respondent completion of a survey'
      }];
      if (_this._hasModules()) {
        receiverTriggeredConditions.push({
          value: 'on_respondent_complete_module_notify',
          label: 'Send on respondent completion of a module'
        });
      }
      receiverTriggeredConditions.push({
        value: 'target_met',
        label: 'When target is met'
      });
      var receiverScheduledConditions = [{
        value: 'target_not_met',
        label: 'If target not met'
      }];
      if (recipientsType.toUpperCase() === NOTE) {
        if (isEditing) {
          if (receiverTriggeredConditions.find(function (c) {
            return c.value === condition;
          })) {
            conditions = conditions.concat(receiverTriggeredConditions);
          } else {
            conditions = conditions.concat(receiverScheduledConditions);
          }
        } else {
          conditions = conditions.concat(receiverTriggeredConditions, receiverScheduledConditions);
        }
      } else if (isEditing) {
        if (respondentTriggeredConditions.find(function (c) {
          return c.value === condition;
        })) {
          conditions = conditions.concat(respondentTriggeredConditions);
        } else {
          conditions = conditions.concat(respondentScheduledConditions);
        }
      } else {
        conditions = conditions.concat(respondentTriggeredConditions, respondentScheduledConditions);
      }
      return conditions;
    });
    _defineProperty(_this, "_getModuleOptions", function () {
      var currentAssignment = _this.props.currentAssignment;
      var condition = _this.state.condition;
      var modulesMap = {};
      if (moduleCompleteConditions.includes(condition)) {
        var navSettings = (0, _get2["default"])(currentAssignment, 'settings.navigationSettings.course.navigationSettings') || (0, _get2["default"])(currentAssignment, 'settings.navigationSettings', {});
        navSettings.modules.forEach(function (mod) {
          if (!(mod !== null && mod !== void 0 && mod.id)) {
            return;
          }
          // if both English and Spanish, this won't include it twice
          modulesMap[mod.id] = {
            id: mod.id,
            title: mod.title || "Module ".concat(mod.id)
          };
        });
      }
      var modules = Object.values(modulesMap);
      modules.unshift({
        id: '',
        title: '--- Select a Module ---'
      });
      return modules;
    });
    _defineProperty(_this, "_getSurveyOptions", function () {
      var currentAssignment = _this.props.currentAssignment;
      var condition = _this.state.condition;
      var surveys = [];
      if (surveyCompleteConditions.includes(condition)) {
        currentAssignment.surveylistList.forEach(function (sl) {
          surveys = surveys.concat(sl.surveyList);
        });
        surveys = (0, _uniqBy2["default"])(surveys, 'surveyHandle');
        surveys = (0, _sortBy2["default"])(surveys, 'position');
      }
      surveys.unshift({
        surveyHandle: '',
        label: '--- Select a Survey ---'
      });
      return surveys;
    });
    _defineProperty(_this, "_hasModules", function () {
      var currentAssignment = _this.props.currentAssignment;
      var navStyle = (0, _get2["default"])(currentAssignment, 'settings.navigationSettings.course.navigation') || (0, _get2["default"])(currentAssignment, 'settings.navigation', '');
      return navStyle.startsWith('module');
    });
    /* ////////////////////////////////////////////////////////////////////////
    // RENDER ////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////// */
    _defineProperty(_this, "renderHtmlTagTooltip", function () {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Can include basic HTML tags, such as <b>, <i>, or <u>")
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)));
    });
    _defineProperty(_this, "checkLabel", /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
        var match;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              match = _this.props.messageList.find(function (item) {
                return item.settings.label === e.target.value;
              });
              if (match) {
                _this.setState({
                  duplicateLabel: true,
                  label: e.target.value
                });
              } else {
                _this.setState({
                  duplicateLabel: false,
                  label: e.target.value
                });
              }
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref0.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "renderMessageInfoFields", function () {
      var currentAssignment = _this.props.currentAssignment;
      var _this$state6 = _this.state,
        currLang = _this$state6.currLang,
        hasSubmitted = _this$state6.hasSubmitted,
        method = _this$state6.method,
        recipientsType = _this$state6.recipientsType;
      var errors = hasSubmitted ? _this.getErrors() : {};
      if (!['sms', 'email'].includes(method) || ![NOTE, 'RESPONDENT'].includes(recipientsType.toUpperCase())) {
        return null;
      }
      var buildLanguages = _this.getLanguages(true);
      if (!buildLanguages.every(function (lang) {
        return typeof lang === 'string';
      }) || buildLanguages.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-warning",
          role: "alert"
        }, currentAssignment.label, " does not have any languages that are marked \"Ready For Build\".");
      }
      var prefix = currLang === 'en' ? '' : currLang + '.';
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_LanguageToggle["default"], {
        languages: buildLanguages,
        errors: errors,
        currLang: currLang,
        setLang: function setLang(lang) {
          return _this.setState({
            currLang: lang
          });
        }
      }), method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': (0, _get2["default"])(errors, "".concat(prefix, "subject"))
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "subject"
      }, "Subject*")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "subject",
        id: "subject",
        className: "form-control",
        value: (0, _get2["default"])(_this.state, "".concat(prefix, "subject"), ''),
        onChange: function onChange(e) {
          _this.setMessageInfoPerLanguage('subject', e.target.value);
        }
      }), (0, _get2["default"])(errors, "".concat(prefix, "subject")) && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, (0, _get2["default"])(errors, "".concat(prefix, "subject")))))), (method === 'email' || method === 'sms') && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': (0, _get2["default"])(errors, "".concat(prefix, "body"))
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "bodyUpper"
      }, "Body", method === 'email' && /*#__PURE__*/_react["default"].createElement("span", null, ' ', "(upper)\xA0", _this.renderHtmlTagTooltip()))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("textarea", {
        className: "form-control",
        id: "bodyUpper",
        name: "bodyUpper",
        value: (0, _get2["default"])(_this.state, "".concat(prefix, "body"), ''),
        onChange: function onChange(e) {
          _this.setMessageInfoPerLanguage('body', e.target.value);
        }
      }), (0, _get2["default"])(errors, "".concat(prefix, "body")) && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, (0, _get2["default"])(errors, "".concat(prefix, "body")))))), method === 'email' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': (0, _get2["default"])(errors, "".concat(prefix, "actionText"))
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "buttonText"
      }, "Button Text")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        name: "buttonText",
        id: "buttonText",
        value: (0, _get2["default"])(_this.state, "".concat(prefix, "actionText"), ''),
        onChange: function onChange(e) {
          _this.setMessageInfoPerLanguage('actionText', e.target.value);
        }
      }), (0, _get2["default"])(errors, "".concat(prefix, "actionText")) && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, (0, _get2["default"])(errors, "".concat(prefix, "actionText"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': (0, _get2["default"])(errors, "".concat(prefix, "actionUrl"))
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "buttonUrl"
      }, "Button URL")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        className: "form-control",
        id: "buttonUrl",
        name: "buttonUrl",
        value: (0, _get2["default"])(_this.state, "".concat(prefix, "actionUrl"), ''),
        onChange: function onChange(e) {
          _this.setMessageInfoPerLanguage('actionUrl', e.target.value);
        }
      }), (0, _get2["default"])(errors, "".concat(prefix, "actionUrl")) && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, (0, _get2["default"])(errors, "".concat(prefix, "actionUrl"))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': (0, _get2["default"])(errors, "".concat(prefix, "outroLines"))
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "bodyLower"
      }, "Body (lower)\xA0", _this.renderHtmlTagTooltip())), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("textarea", {
        className: "form-control",
        name: "bodyLower",
        id: "bodyLower",
        value: (0, _get2["default"])(_this.state, "".concat(prefix, "outroLines"), ''),
        onChange: function onChange(e) {
          _this.setMessageInfoPerLanguage('outroLines', e.target.value);
        }
      }), (0, _get2["default"])(errors, "".concat(prefix, "outroLines")) && /*#__PURE__*/_react["default"].createElement("p", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, (0, _get2["default"])(errors, "".concat(prefix, "outroLines")))))));
    });
    return _this;
  }
  _inherits(SaveMessageModalContents, _React$Component);
  return _createClass(SaveMessageModalContents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeState();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props5 = this.props,
        isEditing = _this$props5.isEditing,
        deployments = _this$props5.deployments,
        deploymentId = _this$props5.deploymentId;
      var _this$state7 = this.state,
        actionText = _this$state7.actionText,
        actionUrl = _this$state7.actionUrl,
        body = _this$state7.body,
        condition = _this$state7.condition,
        currentlyEditingRecList = _this$state7.currentlyEditingRecList,
        currLang = _this$state7.currLang,
        emailRecipients = _this$state7.emailRecipients,
        hasSubmitted = _this$state7.hasSubmitted,
        hasInitialized = _this$state7.hasInitialized,
        isAddingRecipient = _this$state7.isAddingRecipient,
        isRecipientListCollapsed = _this$state7.isRecipientListCollapsed,
        isSubmitting = _this$state7.isSubmitting,
        label = _this$state7.label,
        method = _this$state7.method,
        moduleId = _this$state7.moduleId,
        newRecipient = _this$state7.newRecipient,
        outroLines = _this$state7.outroLines,
        recipientsType = _this$state7.recipientsType,
        scheduleOffsetNumber = _this$state7.scheduleOffsetNumber,
        scheduleOffsetUnits = _this$state7.scheduleOffsetUnits,
        smsRecipients = _this$state7.smsRecipients,
        subject = _this$state7.subject,
        surveyHandle = _this$state7.surveyHandle;
      if (!hasInitialized) {
        return null;
      }

      // collapsed Recipient List style
      var collapseStyle = isRecipientListCollapsed ? _modalstyle_saveMessageScheduleMessage["default"].collapsed : _modalstyle_saveMessageScheduleMessage["default"].expanded;

      // change submit button text if a list is being edited
      var submitVar = currentlyEditingRecList.length > 0 || isAddingRecipient ? 'Save List(s) and Submit' : 'Submit';

      // preview message object
      var previewMessageObject = {
        condition: condition,
        messageMethod: method,
        category: 'preview',
        recipients: [].concat(_toConsumableArray(method === 'email' ? emailRecipients : smsRecipients), [isAddingRecipient && newRecipient]),
        settings: {
          label: label,
          recipientsType: recipientsType,
          surveyHandle: surveyHandle
        },
        messageInfo: currLang === 'en' ? {
          subject: subject,
          body: body,
          outroLines: outroLines,
          actionText: actionText,
          actionUrl: actionUrl
        } : this.state[currLang]
      };
      var deployment = deployments.find(function (d) {
        return d.deploymentId === deploymentId;
      }) || {};
      var errors = hasSubmitted ? this.getErrors() : {};
      var hasErrors = Object.keys(errors).length > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].commonModal, _modalstyle_saveMessageScheduleMessage["default"].saveMessageModal)
      }, /*#__PURE__*/_react["default"].createElement("form", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': errors.label
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "messageLabel"
      }, "Label\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Create a label for this message to help you identify it"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        name: "messageLabel",
        id: "messageLabel",
        className: "form-control",
        placeholder: "Enter a label...",
        value: label,
        onChange: function onChange(e) {
          _this2.checkLabel(e);
        }
      }), this.state.duplicateLabel && this.state.label.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].labelUnavailable
      }, "Label already in use"), !this.state.duplicateLabel && this.state.label.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].labelAvailable
      }, "Label available"), errors.label && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.label))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "recipientsType"
      }, "Recipients")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        id: "recipientsType",
        name: "recipientsType",
        onChange: function onChange(e) {
          _this2.setState({
            recipientsType: e.target.value,
            condition: ''
          });
        },
        value: recipientsType.toLowerCase(),
        disabled: !this.useScheduler(condition) && isEditing
      }, /*#__PURE__*/_react["default"].createElement("option", {
        disabled: recipientsType !== '',
        value: "default"
      }, "-- Choose type --"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "respondent"
      }, "Respondent(s)"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "notification"
      }, "Receiver list ...")))), recipientsType.toUpperCase() === NOTE && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card border-primary', _modalstyle_saveMessageScheduleMessage["default"].field, _modalstyle_saveMessageScheduleMessage["default"].panel)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('card-header text-bg-primary', _modalstyle_saveMessageScheduleMessage["default"].panelHeader)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _modalstyle_saveMessageScheduleMessage["default"].collapseArrow,
        onClick: this.toggleCollapse.bind(null)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: collapseStyle
      }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null))), /*#__PURE__*/_react["default"].createElement("h3", {
        onClick: this.toggleCollapse.bind(null),
        className: "fs-6 card-title"
      }, "Receiver List (", method === 'email' ? emailRecipients.length : smsRecipients.length, ")")), this._renderRecipientsList()), errors.recipients && /*#__PURE__*/_react["default"].createElement("p", {
        className: 'text-danger ' + _modalstyle_saveMessageScheduleMessage["default"].inputError
      }, errors.recipients), /*#__PURE__*/_react["default"].createElement("hr", null)), recipientsType !== '' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': errors.condition
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "condition"
      }, "Condition\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Condition relates to Quest unless otherwise noted."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        id: "condition",
        name: "condition",
        onChange: function onChange(e) {
          _this2.setState({
            condition: e.target.value
          });
        },
        value: condition,
        disabled: !this.useScheduler(condition) && isEditing
      }, (0, _map2["default"])(this._getConditions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index + opt.value,
          value: opt.value,
          disabled: index === 0 && condition !== ''
        }, opt.label);
      })), errors.condition && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.condition))), moduleCompleteConditions.includes(condition) && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': errors.moduleId
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "module"
      }, "Module")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        id: "module",
        name: "module",
        onChange: function onChange(e) {
          _this2.setState({
            moduleId: e.target.value
          });
        },
        value: moduleId
      }, (0, _map2["default"])(this._getModuleOptions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: opt.id
        }, opt.id ? "".concat(opt.id, ": \"").concat(opt.title, "\"") : opt.title);
      })), errors.moduleId && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.moduleId))), surveyCompleteConditions.includes(condition) && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('mb-3 row', {
          'is-invalid': errors.surveyHandle
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "survey"
      }, "Survey")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        id: "survey",
        name: "survey",
        onChange: function onChange(e) {
          _this2.setState({
            surveyHandle: e.target.value
          });
        },
        value: surveyHandle
      }, (0, _map2["default"])(this._getSurveyOptions(), function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: index,
          value: opt.surveyHandle
        }, opt.label);
      })), errors.surveyHandle && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('text-danger', _modalstyle_saveMessageScheduleMessage["default"].inputError)
      }, errors.surveyHandle))), this.useScheduler(condition) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Scheduler["default"], {
        deploymentId: this.props.deploymentId,
        templateMessageObject: this.props.messageObj,
        onScheduleChange: this.onChildrenChange,
        onScheduleError: this.onScheduleError,
        onScheduleErrorResolved: this.onScheduleErrorResolved
      }), /*#__PURE__*/_react["default"].createElement("hr", null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "col-form-label",
        htmlFor: "method"
      }, "Message Type")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/_react["default"].createElement("select", {
        className: "form-select",
        name: "method",
        id: "method",
        onChange: function onChange(e) {
          _this2.setState({
            method: e.target.value,
            isAddingRecipient: false
          });
        },
        value: method.toLowerCase()
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "email"
      }, "Email message"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "sms"
      }, "SMS/text message")))), ['on_respondent_complete', 'on_respondent_complete_notify', 'on_respondent_complete_module', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey', 'on_respondent_complete_survey_notify', 'on_respondent_rostered', 'target_met'].includes(condition) && !!Fortress.user.acting.is_super_user && /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "form-label",
        htmlFor: "scheduleOffsetNumber"
      }, "Schedule Offset\xA0", /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: "Optional delay from the time of the triggering event (whole numbers only)."
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])('text-primary', _style["default"].infoBubble)
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-9 d-flex align-items-start"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        name: "scheduleOffsetNumber",
        id: "scheduleOffsetNumber",
        className: "form-control",
        placeholder: "",
        value: scheduleOffsetNumber,
        onChange: function onChange(e) {
          _this2.onScheduleOffsetNumberChange(e.target.value);
        }
      }), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
        data: [{
          value: 'month',
          label: 'month(s)'
        }, {
          value: 'week',
          label: 'week(s)'
        }, {
          value: 'day',
          label: 'day(s)'
        }, {
          value: 'hour',
          label: 'hour(s)'
        }, {
          value: 'minute',
          label: 'minute(s)'
        }],
        onChange: function onChange(e) {
          _this2.onScheduleOffsetUnitsChange(e.value);
        },
        textField: "label",
        value: scheduleOffsetUnits,
        valueField: "value"
      }))), this.renderMessageInfoFields(), !this.props.hideMessageReplacementNotes && /*#__PURE__*/_react["default"].createElement("div", {
        className: "row mb-3"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'col-9 ' + _modalstyle_saveMessageScheduleMessage["default"].subNote
      }, "Note: To place the Data Collection Wave link in the message, type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%URL%"), " and the link will automatically be filled in when the message is sent. You can also insert", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%firstName%"), ",", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%lastName%"), ", or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%fullName%"), ".", ' ', ['on_respondent_complete_notify', 'on_respondent_complete_module_notify', 'on_respondent_complete_survey_notify'].includes(condition) && /*#__PURE__*/_react["default"].createElement("span", null, "These replacement variables refer to information about the", ' ', /*#__PURE__*/_react["default"].createElement("i", null, "Respondent"), ", not the ", /*#__PURE__*/_react["default"].createElement("i", null, "Recipient"), "."))), !!Fortress.user.acting.is_super_user && !this.props.hideMessageReplacementNotes && /*#__PURE__*/_react["default"].createElement("div", {
        className: "row mb-3"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-3"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'col-9 ' + _modalstyle_saveMessageScheduleMessage["default"].subNote
      }, "To specify the URL of a different deployment, you can use one of the following two forms:", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByHandle:your_custom_handle_here%"), " or", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%dcwURLByEndpoint:your_custom_endpoint_here%"), ". You can specify data starting at the recipient pawn by using a \":\" separated path (e.g.,", ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].bold
      }, "%pawn:data:customPawnField%"), ")."))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary"
        }, "Preview"),
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: _modalstyle_saveMessageScheduleMessage["default"].title
        }, "Previewing message"),
        size: method.toUpperCase() === 'EMAIL' ? 'large' : 'small'
      }, /*#__PURE__*/_react["default"].createElement(_MessageViewer["default"], {
        messageObject: previewMessageObject,
        language: currLang,
        deployment: deployment
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: (0, _classnames["default"])('btn btn-primary', _style["default"].submitButton, recipientsType === '' && 'disabled'),
        type: "button",
        disabled: isSubmitting || recipientsType === '' || hasErrors,
        onClick: function onClick() {
          _this2.setState({
            isSubmitting: true
          });
          _this2.updateAllEditingRecipients();
          if (isAddingRecipient) {
            _this2.addRecipient();
          }
          isEditing ? _this2.onEditSubmit() : _this2.onSaveSubmit();
        }
      }, isSubmitting ? 'Submitting...' : submitVar))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(SaveMessageModalContents, "propTypes", {
  assignments: _propTypes["default"].array,
  closeModal: _propTypes["default"].func,
  currentAssignment: _propTypes["default"].object,
  deploymentId: _propTypes["default"].number.isRequired,
  deployments: _propTypes["default"].array,
  messageList: _propTypes["default"].array,
  hideMessageReplacementNotes: _propTypes["default"].bool,
  isEditing: _propTypes["default"].bool,
  messageObj: _propTypes["default"].object,
  requeryCallback: _propTypes["default"].func
});
_defineProperty(SaveMessageModalContents, "defaultProps", {
  messageObj: null
});
var mapStateToProps = function mapStateToProps(state, props) {
  var assignments = (0, _admin.getCurrentProjectAssignments)(state.assignment.admin);
  return {
    assignments: assignments,
    currentAssignment: assignments.find(function (a) {
      return a.deploymentList.find(function (d) {
        return Number(d.deploymentId) === Number(props.deploymentId);
      });
    }),
    deployments: (0, _admin.getCurrentProjectDeployments)(state.assignment.admin)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(SaveMessageModalContents);